import React from 'react';
import { FormikProps, withFormik } from 'formik';

import { AdminRole } from '@/types/affiliation';
import { emailSchema } from '@/services/validators/email';

import { FormContents, Values } from './FormContents';

type OuterProps = {
  isLoading: boolean;
  inviteAffiliation: (email: string, role: AdminRole) => void;
};

export const InviteForm = withFormik<OuterProps, Values>({
  mapPropsToValues: () => ({
    email: '',
    role: 'member',
  }),
  validationSchema: emailSchema,
  handleSubmit: (values, { props }) => {
    props.inviteAffiliation(values.email, values.role);
  },
  enableReinitialize: true,
})(
  // enhanced form
  ({
    errors,
    handleSubmit,
    handleChange,
    setFieldValue,
    isLoading = false,
    values,
  }: OuterProps & FormikProps<Values>) => {
    return (
      <FormContents
        errors={errors}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        setFieldValue={setFieldValue}
        values={values}
      />
    );
  },
);
